module.exports = __webpack_public_path__ + "img/welcome.75123906.png";